module.exports = __webpack_public_path__ + "static/media/mainheader.c435298b.svg";